// Collection wishlist
document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

var html = document.documentElement;
var isMacLike = !!navigator.platform && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
if (isMacLike) {
    html.classList.add('isMac');
}

// Check with brower safari
if (navigator.userAgent.indexOf('Safari') != -1 &&
    navigator.userAgent.indexOf('Chrome') == -1) {
    html.classList.add("isSafari");
}


// Template collection customer review
if($(window).width() < 769){
    $('.template-collection .reviews-customer--mob-carousel .js-reviews-customer-carousel').slick({
        infinite: true,
        slidesToShow: 1, 
        slidesToScroll: 1, 
        arrows: true, 
        dots: true 
    });
}else {
    $('.template-collection .reviews-customer--carousel .js-reviews-customer-carousel').slick({
        infinite: true,
        slidesToShow: 2, 
        slidesToScroll: 1, 
        arrows: true, 
        dots: true 
    });
}

// Home brand
$(document).ready(function () {
    $('.home-brand .item-brand').slick({
        infinite: true,
        slidesToShow: 5, 
        slidesToScroll: 1, 
        arrows: true, 
        dots: false,
        responsive: [
            {
            breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            },

            {
                breakpoint: 767,
                settings: {
                    rows: 2,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
        ],
    })
})

// Home slider banner
function windowResizeFunc() {
    $('.slider-custom .slider-item').not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
    });
}

windowResizeFunc();

$(window).on('resize orientationchange', function() {
    windowResizeFunc();
});

// Home page block text
if ($(window).width() > 650){
    $('.content-show-more').readmore({
        speed: 500,
        collapsedHeight: 100, 
        collapsedMoreHeight: 100,
        moreLink: '<a class="show-more" href="#">Show more</a>', 
        lessLink: '<a class="show-less" href="#">Less</a>', 
    });
}else {
    $('.content-show-more').readmore({
        speed: 500,
        collapsedHeight: 145, 
        collapsedMoreHeight: 145,
        moreLink: '<a class="show-more" href="#">Show more</a>', 
        lessLink: '<a class="show-less" href="#">Less</a>', 
      });
}

// Menu secondary
$(document).ready(function () {
    if ($(window).width() < 1110) {
        $('#shopify-section-header-seconary').appendTo('.header-menu--secondary__mobile');
    }
});


// Collection page 
$('.collection__description').readmore({
    speed: 500,
    collapsedHeight: 100, 
    collapsedMoreHeight: 100,
    moreLink: '<a class="show-more" href="#">Show more</a>', 
    lessLink: '<a class="show-less" href="#">Less</a>', 
});


//Mega menu 
$('.mobile-nav__item--sub a.mobile-nav__link span').on('click',function(){
    $(this).parents('.mobile-nav__item--sub').toggleClass('active');
});

$('.mobile-nav__sub__item a.mobile-nav__sub__link span').on('click',function(){
    $(this).parents('.mobile-nav__sub__item').toggleClass('active');
});

//=========================== 
// Product Detail 
//===========================
// $('.js-swatch-variant-title').text($('.js-swatch-color-item :radio:checked').val());

$('.product-name--gift-card .product-detail-description h3').on('click',function(){
    $(this).parents('.product-detail-description').toggleClass("active");
})


// Anchor on PDP
$(document).ready(function () {
   
    $(".tab-item:first-child").addClass("active");

   $('.tab-accordion li a').bind('click',function(event){
        var $anchor = $(this);
        // Sticky tab on PDP
        if ($(window).width() > 1023) {
            $(this).parents('.tab-accordion').addClass('sticky');
            $(this).parents('body').addClass('sticky');
        }

        $('.tab-item.active').not($anchor).removeClass('active');
        $(this).parent().addClass('active');
          $('html, body').stop().animate({
          scrollTop: $($anchor.attr('href')).offset().top - 70
          }, 1000);
    
        event.preventDefault();
    });

    // Sticky tab on PDP
    if ($(window).width() > 1023) {
        $('.tab-accordion li:first-child').bind('click',function(event){
            $(this).parents('.tab-accordion').removeClass('sticky');
            $(this).parents('body').removeClass('sticky');
        });
    
        $(window).scroll(function(){
            if ($(this).scrollTop() > 1400) {
                $('.tab-accordion').addClass('sticky');
            }else {
                $('.tab-accordion').removeClass('sticky');
            }
        });
    }

    $(window).scroll(function(){
        if ($(this).scrollTop() > 1400) {
            $('body').addClass('sticky');
        }else {
            $('body').removeClass('sticky');
        }
    });
    // End Sticky tab on PDP
    
    // Header sticky 
    if ($(window).width() > 1024) { 
       $(window).scroll(function(){
            if ($(this).scrollTop() > 50) {
                $('body').addClass('sticky-header');
            }else {
                $('body').removeClass('sticky-header');
            }
        });
    }

 // Stiky PDP bottom button
    if ($('[class^="template-product-default-"]').length != 1) {
        if ($(window).width() > 1024) {
            $(window).scroll(function () {
                if ($(this).scrollTop() > 500) {
                    $('body').addClass('sticky-button');
                } else {
                    $('body').removeClass('sticky-button');
                }
            });
        } else {
            $(window).scroll(function () {
                if ($(this).scrollTop() > 1000) {
                    $('body').addClass('sticky-button');
                } else {
                    $('body').removeClass('sticky-button');
                }
            });
        }

        //  End Stiky PDP bottom button
        if ($(window).width() > 640 && $(window).width() < 1023) {
            $(window).scroll(function () {
                if ($(this).scrollTop() > 1200) {
                    $('body').addClass('sticky-button');
                } else {
                    $('body').removeClass('sticky-button');
                }
            });
        }
    }

   $(document).on('click', '.js-faqs-title', function() {
        $(this).parent().toggleClass('active').find('.faqs__answer').slideToggle(200);        
    })

    if($('.cms-campaign').length){
        $('body').addClass('campaign-template');
    }else{
        $('body').removeClass('campaign-template');
    }
    $(document).on('click', '.show-more', function() {
        $('.product-detail-description').addClass("hidden-overlay");        
    })
    $(document).on('click', '.show-less', function() {
        $('.product-detail-description').removeClass("hidden-overlay");        
    })
    
    if($('.product-detail-description .main-content-detail').outerHeight() == 0){
        $('.product-detail-description').addClass("no-desc");
    }
    if($('.product-detail-description .main-content-detail').outerHeight() < 250.99){
        $('.product-detail-description').addClass("no-more");
    }
    
    $('.banner-text-with-image-product table tr td').each(function () {
        var set = $(this).find('figure');
        if(set.hasClass('image')){
            set.parent().addClass('col-image');
        }else{
            set.parent().removeClass('col-image');
        }
    });

    if(navigator.userAgent.indexOf('Mac') > 0){
        $('body').addClass('mac-os');
    }
});

//  slick product thumbnail
$('.main_images.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
});

$('.product__media-list.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    // dots: true,
    focusOnSelect: true
});

// Slick image on mobile PDP
$('.product-slider-mobile ul').slick({
    dots: true,
    speed: 1000,
    infinite: true,
    prevArrow: false,
    nextArrow: false,
    autoplay: false
    // autoplaySpeed: 3000
});

// PDP calculator remove event default
$('.oct-calculator-open').on("click", function (e) {
    e.preventDefault();
})

// Blog detail
$('.share-button__button').on('click',function(){
    $(this).parent('.share-blog').toggleClass('active');
});

 // Count minicart ajax
 $(document).ready(function() {
    $(".js-ajax-add-to-cart").click(function() {
      setTimeout(function() {
        $.getJSON('/cart.js', function(cart) {
            $("span.count").html('View my cart' + '(' + cart.item_count + ')');
         });
       }, 200);

        if ($('[class^="template-product-default-"]').length != 1) {
            $('html, body').animate({ scrollTop: 0 }, 'slow');
        }

        // Picky app add to cart
        // setTimeout(function(){
        //   $('.picky-add-selected-to-cart-button').trigger("click");
        // }, 2000)
 
    });
  });

  $(document).ready(function() {
    $('.js-ajax-cart-drawer-trigger').click(function(){
        window.location.href='/cart';
    })
});

if ($('.ajax-cart-item__title:contains("Gift Card")').length > 0) {
    $(this).parent('.content-minicart').addClass('removeFa');
}


// PDP bundle 
$(document).ready(function() {
    $('.picky-bundler-container h4').on('click',function(){
        $(this).parents('.picky-bundler-container').toggleClass('active-bundle');
    });
});

// PDP picky app
$(document).ready(function(){
     setTimeout(function(){
        $('.picky-bundler-container').appendTo('.main-layout-pickystory')
     }, 3000)
})


// Add view more button on collection page
setTimeout(function () {
    $('.collection-list #product-grid li.active').nextAll().hide();
    $('.view-all').show();
}, 3000)

$('.collection-list .view-all').on("click", function () {
    $('#product-grid li.active').nextAll().show();
    $('.view-all').hide();
})

// $(document).delegate('.js-load-more','click', function(){
//     var $this =$(this),
//     totalPages = parseInt($this.attr('data-max')),
//     currentPage = parseInt($this.attr('data-current'));
//     $this.attr('disabled', true);
//     $this.find('.load-more-text').addClass('hide');
//     $this.find('[loader]').removeClass('hide');
//     var nextUrl = $this.attr('data-next-link');
//     var current_page_new = currentPage + 1;
//     var next_coll = currentPage + 2;
//     var parser = document.createElement('a');
//     parser.href = window.location.href;
//     var query = parser.search.substring(1);
//     if(currentPage >= totalPages) {
//         $this.find('.load-more-text').text('Products Finished').removeClass('hide'); $this.find('[loader]').addClass('hide');
//         return;
        
//     }
//     $.ajax({
//         url: nextUrl,
//         type: 'GET',
//         dataType: 'html',
//         success: function(responseHTML){
//             $this.attr('data-next-link', window.location.pathname + "?page="+next_coll +'&'+ query);
//             $this.attr('data-current', current_page_new);
//             $('.grid--view-items').append($(responseHTML).find('.grid--view-items').html());
//         },

//         complete: function() {
//             if(current_page_new < totalPages) {
//                 $this.attr('disabled', false); $this.find('.load-more-text').removeClass('hide'); $this.find('[loader]').addClass('hide');
//             } 
//             if(current_page_new >= totalPages) {
//                 $this.find('.load-more-text').text('Products Finished').removeClass('hide'); $this.find('[loader]').addClass('hide');
//             } 
          
//             //swym collections wishlist button dynamic initialization
//             document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
                
//             // Fix yotpo not showing in collection when load more
//             var api = new Yotpo.API(yotpo);
//             api.refreshWidgets();
//         }
//     })

// });

// remove spacing when show Products Finished
// $('button.btn.js-load-more.button-view-all:disabled').parents(".load-more_wrap").addClass('active-hidden');


// Gift cart
$('body').on('click', '.swatch-element', function(){
    $('.product-name--gift-card .swatch-element').removeClass('change-bg');
    $('.select-swatch-value').removeClass('remove-bg-selected');
    $(this).addClass('change-bg');
    var thisVariantName = $(this).data('value').replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-').toLocaleLowerCase();
    $('#variant_selected option').each(function () {
        if (thisVariantName === $(this).data('variant-name').replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-').toLocaleLowerCase()){
            $('#variant_selected').val($(this).val()).trigger('change');
            return false;
        }
    });
 });
$(document).ready(function () {
    var currentURL = window.location.href,
        currentVariant = $('.swatch-element[data-id="'+getUrlVars(currentURL).variant+'"]');
    if (currentVariant.length){
        currentVariant.trigger('click');
        $('.select-swatch-value').addClass('remove-bg-selected');
    }
});
function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

// Menu on mobile
$(document).ready(function () {
    $(".js-toggle-trigger").on('click', function () {
        $(this).parents('.mobile-nav__item').toggleClass('active');
    });
    
});


$(".mobile-nav__sub__link.hide").parent().addClass("remove-category-product");

// Collection filter category
$('.category-filter-collection .facets__title').on('click', function (event){
    $(this).parent('.category-filter-collection').toggleClass('active');
});

// remove class when click outside
$(document).on('click',function (event){
    if (!$(event.target).closest('.category-filter-collection').length){
        $(".category-filter-collection").removeClass("active");
     }
})

if($('.facets__list__category').length) {
    var url = window.location.href;
    $(".facets__list__category > li > a").each(function () {
        var urla = $(this).attr("href");
        if (url == urla) {
            $(this).addClass("active-link");
        }
    });

}

// Menu tab filter category
$('.category-tab-collection .mobile-facets__submenu').on('click',function(){
    $(this).parents('.category-tab-collection').removeClass('menu-opening');
});

$('.category-tab-collection .mobile-facets__summary_category span').on('click',function(){
    $(this).parents('.category-tab-collection').addClass('menu-opening');
});


// Menu mobie
$('.menu-drawer-container .overlay-menu').on('click',function(){
    $(this).parent('#shopify-section-mobile-drawer').siblings('.header__icon--menu').trigger('click');
});


// remove class when click outside Popup bundle
$(document).on('click',function (event){
    setTimeout(function() { 
        if (!$(event.target).closest('.Modal_content_3c9D4').length){
          $(".Modal_picky-modal_2hpGv").css("display","none");
        }
    });
})  

$(document).ready(function() {
    setTimeout(function() { 
        $('.AddSelectedToCart_picky-retail-price_1bAh6').parent("div").addClass("has-sale");
    }, 5000);
    
    // Fix button Pre order when end date
    setTimeout(() => {
        $('#btn-preOrder').append('<span class="text-end-date">Add to cart </span>');
    },4000);

    // CMS videos 
    $(document).ready(function () { 
        $('.grid-video .image__thumbnail, .grid-video .image-icon__play').on('click', function () {
            $(this).parents('.grid_video_item').addClass('active_video');
        })
    })

    // Breadcrumb 

    $('li.breadcrumbs__item.collection_title').each(function() {
    if ( $.trim( $(this).text() ).length == 0 ) {
        $(this).addClass("hide");
    }
    });  

    // Menu region
    $('.menu-region .current-region a').on("click", function () {
        $(this).parents(".menu-region").toggleClass("active");
    })

});


// Show more/ show less
$('.show-more').on("click", function (e) {
    e.preventDefault();
    $(this).parents().addClass("show-full")
})

$('.show-less').on("click", function (e) {
    e.preventDefault();
    $(this).parents().removeClass("show-full")
})

// Section Blog recommend in product
if ($(window).width() < 1000) {
    $('.blog__posts_articles-wrapper').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        responsive: [
        {
            breakpoint: 980,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            
             {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
        },
        ],
    })
}

$('.other-articles__picture.has_video').on("click", function () {
    $(this).addClass("remove_image"); 
     $('.has_video_item video')[0].play()
});

